
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

type LoadingScreenVariant = 'generic' | 'complete_history';

interface LoadingScreenProps {
  variant?: LoadingScreenVariant;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ variant = 'generic' }) => {
  const { t } = useLanguage();
  const title = variant === 'complete_history' ? t('loading.title') : t('loading.genericTitle');
  const subtitle = variant === 'complete_history' ? t('loading.subtitle') : t('loading.genericSubtitle');

  return (
    <div className="min-h-screen w-full bg-slate-100 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="text-center space-y-5">
          <div className="mx-auto relative h-20 w-20">
            <div className="absolute inset-0 rounded-full border-4 border-slate-300 dark:border-slate-700" />
            <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-blue-600 dark:border-t-cyan-300 animate-spin" />
            <div className="absolute inset-3 rounded-full border-2 border-transparent border-t-cyan-500 dark:border-t-blue-300 animate-spin [animation-direction:reverse] [animation-duration:1.2s]" />
          </div>
          <div className="space-y-2">
            <h3 className="text-2xl font-bold">
              {title}
            </h3>
            <p className="text-slate-600 dark:text-slate-300">
              {subtitle}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
